import {FLEX_OFFER, FlexOffer, FlexOfferRestriction, FlexOfferType, RedemptionRange} from "../types";
import { FlexOfferServiceError } from "../Errors/FlexOfferServiceError";
import type {WidgetFlexOfferResponse} from "@bookingkit/api-v4/models/widget-flex-offer-response";
import type {
    WidgetFlexOfferRestrictionsResponse
} from "@bookingkit/api-v4/models/widget-flex-offer-restrictions-response";
import {
    WidgetFlexOfferRestrictionsResponseRedemptionRange
} from "@bookingkit/api-v4/models/widget-flex-offer-restrictions-response-redemption-range";


export const mapFlexOffers = (flexOffer:WidgetFlexOfferResponse):FlexOffer => {
    const {id, name, description, experience_id, option_id, restrictions, type} = flexOffer;
    if (id === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('id', 'string', id);
    }
    if (name === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('name', 'string', name);
    }
    if (experience_id === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('experience', 'string', experience_id);
    }
    if (option_id === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('experience', 'string', option_id);
    }
    if (type === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('type', 'FlexOfferType', type);
    }

    const mapRedemptionRange = (redemptionRange?: WidgetFlexOfferRestrictionsResponseRedemptionRange | null):RedemptionRange | undefined=> {
        if(redemptionRange) {
            if(redemptionRange?.type === 'DATE_RANGE') {
                return {
                    type: 'DATE_RANGE',
                    startDate: new Date(redemptionRange.start_date),
                    endDate: new Date(redemptionRange.end_date),
                }
            }
            if(redemptionRange?.type === 'DAYS_AFTER_PURCHASE') {
                return {
                    type: 'DAYS_AFTER_PURCHASE',
                    daysAfterPurchase: redemptionRange.days_after_purchase,
                }
            }
        }
        return undefined;
    }

     const mapRestrictions = (restriction?: WidgetFlexOfferRestrictionsResponse):FlexOfferRestriction | undefined => {
        if(restrictions) {
            return {
                numberOfRedemptions : restrictions.number_of_redemptions,
                limitedStockAmount: restrictions.limited_stock_amount,
                redemptionRange: mapRedemptionRange(restriction?.redemption_range),
            }
        }
        return undefined;
     }
    return {
        inventoryType: FLEX_OFFER,
        id: id as string,
        name: name,
        type: type as FlexOfferType,
        description: description || '',
        experienceId: experience_id,
        optionId: option_id,
        restrictions: mapRestrictions(restrictions),
    }
};
